import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileComponent } from './pages/profile/profile.component';
import { ScheduleSelectComponent } from './pages/schedule/select/schedule-select.component';
import { PractitionerPatientComponent } from './pages/patient/patient.component';
import { PractitionerOrganizationComponent } from './pages/organization/organization.component';
import { PractitionerCalendarComponent } from './pages/calendar/calendar.component';
import { PractitionerScheduleStatusComponent } from './pages/schedule/status/schedule-status.component';
import { FirstAccessGuard } from 'app/core/guards/first-access.guard';
import { PractitionerScheduleComponent } from './pages/schedule/schedule.component';
import { PractitionerScheduleAppointmentComponent } from './pages/schedule/appointment/schedule-appointment.component';
import { PractitionerScheduleProcedureComponent } from './pages/schedule/procedure/schedule-procedure.component';
import { PractitionerDashboardComponent } from './pages/dashboard/dashboard.component';
import { PractitionerRevenueComponent } from './pages/revenue/revenue.component';
import { UserTypeGuard } from 'app/core/guards/user-type.guard';
import { AuthGuard } from 'app/core/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: ScheduleSelectComponent,
    canActivate: [FirstAccessGuard, AuthGuard, UserTypeGuard],
    data: {
      onlyUserType: 'practitioner',
    },
  },
  {
    path: 'home',
    component: PractitionerDashboardComponent,
    canActivate: [FirstAccessGuard, AuthGuard, UserTypeGuard],
    data: {
      onlyUserType: 'practitioner',
    },
  },
  {
    path: 'agenda',
    component: ScheduleSelectComponent,
    canActivate: [FirstAccessGuard, AuthGuard, UserTypeGuard],
    data: {
      onlyUserType: 'practitioner',
    },
  },
  {
    path: 'agenda/status',
    component: PractitionerScheduleStatusComponent,
    canActivate: [FirstAccessGuard, AuthGuard, UserTypeGuard],
    data: {
      onlyUserType: 'practitioner',
    },
  },
  {
    path: 'agenda/calendario',
    component: PractitionerCalendarComponent,
    canActivate: [FirstAccessGuard, AuthGuard, UserTypeGuard],
    data: {
      onlyUserType: 'practitioner',
    },
  },
  {
    path: 'agendar',
    component: PractitionerScheduleComponent,
    canActivate: [FirstAccessGuard, AuthGuard, UserTypeGuard],
    data: {
      onlyUserType: 'practitioner',
    },
  },
  {
    path: 'agendar/consulta',
    component: PractitionerScheduleAppointmentComponent,
    canActivate: [FirstAccessGuard, AuthGuard, UserTypeGuard],
    data: {
      onlyUserType: 'practitioner',
    },
  },
  {
    path: 'agendar/exame',
    component: PractitionerScheduleProcedureComponent,
    canActivate: [FirstAccessGuard, AuthGuard, UserTypeGuard],
    data: {
      onlyUserType: 'practitioner',
    },
  },
  {
    path: 'meus-dados',
    component: ProfileComponent,
    canActivate: [AuthGuard, UserTypeGuard],
    data: {
      onlyUserType: 'practitioner',
    },
  },
  {
    path: 'pacientes',
    component: PractitionerPatientComponent,
    canActivate: [FirstAccessGuard, AuthGuard, UserTypeGuard],
    data: {
      onlyUserType: 'practitioner',
    },
  },
  {
    path: 'instituicoes',
    component: PractitionerOrganizationComponent,
    canActivate: [FirstAccessGuard, AuthGuard, UserTypeGuard],
    data: {
      onlyUserType: 'practitioner',
    },
  },
  {
    path: 'faturamento',
    component: PractitionerRevenueComponent,
    canActivate: [FirstAccessGuard, AuthGuard, UserTypeGuard],
    data: {
      onlyUserType: 'practitioner',
    },
  },
  {
    path: 'dashboard',
    component: PractitionerDashboardComponent,
    canActivate: [FirstAccessGuard, AuthGuard, UserTypeGuard],
    data: {
      onlyUserType: 'practitioner',
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PractionerRoutingModule {}
